<template>
  <v-container fluid>
    <!-- <div class="overall-score">
      <span color="grey lighten-2" style="font-size: 11px">Aggregate Score: </span>
      <v-progress-circular class="ms-3" :rotate="360" :size="75" :width="15" :color="color"
        :value="editData.overallScore">
        <span style="font-size: 11px">{{ editData.overallScore }}%</span>
      </v-progress-circular>
    </div> -->
    <material-card icon="mdi-clipboard-text" inline :title="title">

      <v-card-actions>
        <a @click="$router.back()">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1"
            class="mr-n2 mt-10" style="opacity:.6;">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </a>
      </v-card-actions>
      <v-card-component v-if="!editData">
        <p class="text-center">No Data Found</p>
      </v-card-component>
      <v-card-component v-if="editData">
        <v-row>
          <v-col cols="12" md="4">
            <v-col cols="12" md="12">
              <span class="desc">
                <v-icon>mdi-calendar</v-icon> Month: {{this.editData.month }}
              </span>
            </v-col>
            <v-col cols="12" md="12">
              <span class="desc">
                <v-icon>mdi-notebook-outline</v-icon> Class: {{this.editData.className[0].name}}
              </span>
            </v-col>

          </v-col>
          <v-col cols="12" md="4">
            <v-col cols="12" md="12">
              <span class="desc">
                <v-icon>mdi-billboard</v-icon> Center:
                {{this.editData.FranchiseeName[0].companyName}}
              </span>
            </v-col>
            <v-col cols="12" md="12">
              <span class="desc">
                <v-icon>mdi-account</v-icon> Audited by:
                {{this.editData.auditedByName[0].firstName+" "+this.editData.auditedByName[0].lastName}}
              </span>
            </v-col>
          </v-col>
          <v-col cols="12" md="4">
            Aggregate Score
            <v-progress-circular class="ms-3" :rotate="360" :size="75" :width="15" :color="color"
              :value="editData.overallScore">
              <span style="font-size: 11px">{{ editData.overallScore }}%</span>
            </v-progress-circular>
            <v-row class="mt-3">
              <v-col class="pt-4" cols="12" md="2">
                <label>Grade:</label>
              </v-col>
              <v-col :class="`${starCount===0 ? 'pl-0 ms-0 pt-4' : 'pl-0 ms-0'}`" cols="12" sm="10">
                <v-rating v-if="starCount!==0" readonly color="warning" background-color="gray"
                  disabled empty-icon="mdi-star-outline" full-icon="mdi-star"
                  half-icon="mdi-star-half" half-increments length="3" size="15" :value="starCount">
                </v-rating>
                <span v-else>Not Applicable</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <!-- Audited By: {{this.editData.}} -->
        <form autocomplete="off" @submit.prevent="save">
          <!--+++++++++++++++++++++++++++Category Fields Start++++++++++++++++++++++++++++++++++++++++++-->
          <v-container v-for="item in categoryData" :key="item.id">
            <v-row>
              <v-col>
                <p class="mb-0 mt-5 me-auto" style="width: 100%;">
                  <strong class="header-title ml-3">
                    <v-icon>mdi-checkbox-marked</v-icon> {{item.categoryName}}
                  </strong>

                </p>

              </v-col>
              <v-col cols="12" md="3">

                <p class="mb-0 mt-5">Score:
                  {{ Math.round(parseFloat(item.score))===0 ? 'NA' : item.score+'%' }}</p>
              </v-col>
            </v-row>
            <!-- <v-divider class="my-0 hr-divider" /> -->
            <v-data-table :headers="headers" :items="item.acadAuditParameterMaps" disable-pagination
              hide-default-footer>
              <template v-slot:item.score="{item}">
                <span v-if="Math.round(parseFloat(item.score))===0">
                  NA
                </span>
                <span v-else>{{item.score+"/"+outOfScore}}</span>
                <!-- <v-rating readonly color="warning" background-color="gray" disabled
                  empty-icon="mdi-star-outline" full-icon="mdi-star" half-icon="mdi-star-half"
                  half-increments length="5" size="15" :value="item.score">
                </v-rating> -->
                <!-- <v-autocomplete label="Select Score" clearable v-model="item.score"
                     :items="scoreList" key="id"
                    item-value="value" item-text="value"> </v-autocomplete> -->
              </template>
            </v-data-table>
            <v-col class="pl-0 pr-0" cols="12">
              <v-text-field readonly v-model="item.remark" label="Remarks" color="#5d58ef" outlined>
              </v-text-field>
            </v-col>
          </v-container>
          <!--+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->
          <v-col class="pl-0 pr-0" cols="12">
            <v-text-field readonly v-model="formData.overallRemark" label="Overall Remarks"
              color="#5d58ef" outlined>
            </v-text-field>
          </v-col>
        </form>
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import { mapGetters } from 'vuex'
import _ from 'lodash'
// import stores from '@/stores'
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import moment from 'moment'

export default {
  components: { VCardComponent, MaterialCard },
  props: ['id'],
  data () {
    return {
      title: 'Audit Report',
      color: 'red',
      percentage: 0,
      editData: null,
      centreList: [],
      classList: [],
      teacherList: [],
      isLoading: false,
      categoryData: [],
      acadamicYearData: [],
      starCount: 0,
      scoreList: [],
      outOfScore: 0,
      formData: {
        auditDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        overallRemark: '',
        academicYearID: '',
        classID: '',
        auditeeID: '',
        franchiseeID: '',
        auditTitle: '',
        status: 'NA'
      },
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menu1: false,
      noOfFields: 0,
      headers: [
        { text: 'Parameter', value: 'parameter', sortable: false, width: '70%' },
        { text: 'Score', value: 'score', sortable: false }
      ]
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    formData: {
      handler: function () {
        this.formProgressCaluculation()
      },
      deep: true
    },
    academicYear: function (val) {
      if (val) {
        console.log('____Academic ID____', val.academicYear)
        // this.formData.academicYearID = val.id
        this.getTeacherList()
      }
    }
  },
  created: async function () {
    await this.getAcadById()
  },
  methods: {
    getAcadById: async function () {
      try {
        let rows = await http.get(`${CONSTANTS.API_URL}/api/center-audit/audit/${this.id}`)
        console.log('____ACad by ID__', rows.data)
        this.editData = rows.data
        // Patching the previous values
        this.formData.auditTitle = this.editData.auditTitle
        this.formData.auditDate = moment(new Date(this.editData.auditDate)).format('YYYY-MM-DD')
        this.formData.overallRemark = this.editData.overallRemark
        this.formData.auditeeID = this.editData.auditeeID
        this.formData.academicYearID = this.editData.academicYearID
        this.formData.classID = this.editData.classID
        this.formData.franchiseeID = this.editData.franchiseeID
        let totalScore = parseInt(this.editData.overallScore)
        // Grading based on overall score
        if (totalScore >= 75) {
          this.starCount = 3
          this.color = 'teal'
        } else if (totalScore >= 51) {
          this.color = 'orange'
          this.starCount = 2
        } else if (totalScore >= 36) {
          this.color = 'red'
          this.starCount = 1
        } else if (totalScore <= 35) {
          this.color = 'red'
          this.starCount = 0
        }
        await this.getFranchisee()
        let parameters = []
        this.editData.acadAuditCategoryMaps.map((data) => {
          parameters = parameters.concat(data.acadAuditParameterMaps)
        })
        this.editData.month = moment(this.editData.auditDate).format('MMMM')
        // this.title = `${this.editData.month} ${this.title}`
        // this.title = this.editData.auditTitle
        this.title = this.editData.auditeeName[0].firstName + ' ' + this.editData.auditeeName[0].lastName
        console.log('___Fetch Data')
        console.log(this.editData.acadAuditCategoryMaps)
        // Sorting category array based on position
        this.editData.acadAuditCategoryMaps = _.orderBy(this.editData.acadAuditCategoryMaps, ['position'], ['asc'])

        // Sorting parameter array based on position
        this.editData.acadAuditCategoryMaps.map((item) => {
          item.acadAuditParameterMaps = _.orderBy(item.acadAuditParameterMaps, ['position'], ['asc'])
        })
        this.categoryData = this.editData.acadAuditCategoryMaps
        // await this.getCategories(parameters, this.editData.acadAuditCategoryMaps)
        // await this.getAcadamicYearsList()
        await this.getScoreList()
        // await this.getClassList()
        // await this.getTeacherList()
      } catch (e) {
        this.editData = null
      }
    },
    async getScoreList () {
      let rows = await http.get(`${CONSTANTS.API_URL}/api/center-audit/score/points`)
      this.scoreList = rows.data
      this.outOfScore = this.scoreList.reduce((a, b) => {
        return parseInt(a.value) < parseInt(b.value) ? a.value : b.value
      })
    },
    async getTeacherList () {
      this.formData.academicYearID = this.academicYear.id
      if (this.formData.franchiseeID && this.formData.academicYearID) {
        // staff/teacher-class-map
        let rows = await http.get(`${CONSTANTS.API_URL}/api/staff/approved`, {
          params: {
            franchiseeID: this.formData.franchiseeID,
            isTeachingStaff: true
          }
        })
        // console.log('____Teacher list___', rows.data)
        this.teacherList = rows.data
        this.getClassList()
      }
    },
    async getClassList () {
      this.formData.academicYearID = this.academicYear.id
      if (this.formData.franchiseeID && this.formData.academicYearID) {
        let rows = await http.get(`${CONSTANTS.API_URL}/api/student/get-all-classby-franchisee`, {
          params: {
            franchiseeID: this.formData.franchiseeID,
            academicYearID: this.formData.academicYearID
          }
        })
        // console.log('___Class List___', rows.data)
        this.classList = rows.data
      }
    },
    formProgressInit () {
      this.noOfFields = Object.keys(this.formData).length
      this.categoryData.forEach((element) => {
        element.acadAuditParameters = element.acadAuditCategory.acadAuditParameters.map((item) => {
          // item.score = 'NA'
          console.log('____SCORE: ' + item.score)
          this.noOfFields++
          return item
        })
      })
      this.noOfFields += this.categoryData.length
    },
    formProgressCaluculation () {
      console.log('_____Form Progress Calc___')
      let invalidFieldCount = 0
      Object.keys(this.formData).map((key) => {
        if (!this.formData[key]) {
          invalidFieldCount++
        }
      })
      this.categoryData.forEach((element) => {
        if (!element.remark) {
          invalidFieldCount++
        }

        element.acadAuditParameters.map((item) => {
          if (!item.score) {
            invalidFieldCount++
          }
        })
      })
      let filledFields = this.noOfFields - invalidFieldCount
      this.percentage = (filledFields / this.noOfFields) * 100
      // console.log('Total Fields: ', this.noOfFields)
      // console.log('Invalid Fields: ', invalidFieldCount)
      // console.log('Filled Fields: ', filledFields)
      // console.log('Percentage: ', this.percentage)
      return this.noOfFields === filledFields
    },
    getCategories: async function (parameters = [], category = []) {
      try {
        if (this.formData.classID && this.formData.academicYearID) {
          let rows = await http.get(`${CONSTANTS.API_URL}/api/center-audit/category/classes`, {
            params: {
              classID: this.formData.classID,
              academicYearID: this.formData.academicYearID,
              type: this.editData.type
            }
          })
          this.categoryData = rows.data

          let flagIndexes = []
          this.categoryData = this.categoryData.map((item, index) => {
            item.name = item.acadAuditCategory.name
            let flag = false
            category.forEach((cat) => {
              if (cat.categoryID === item.categoryID) {
                flag = true
                item.score = cat.score
                item.remark = cat.remark
                item.updateId = cat.id
              }
            })
            if (!flag) {
              flagIndexes.push(index)
            }

            item.acadAuditParameters = item.acadAuditCategory.acadAuditParameters.map((ele) => {
              parameters.forEach((param) => {
                if (param.parameterID === ele.id) {
                  // Previous entry found patching it
                  ele.updateId = param.id
                  ele.score = param.score
                }
              })
              if (!ele.score) {
                ele.score = 'NA'
              }
              return ele
            })
            return item
          })
          flagIndexes.forEach((index) => {
            // Deleting the newly added categories
            this.categoryData.splice(index, 1)
          })
          console.log('___Cat Data')
          console.log(this.categoryData)

          // this.formProgressInit()
          // this.formProgressCaluculation()
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
      }
    },
    getFranchisee: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${CONSTANTS.API_URL}/api/franchisee`)
        this.centreList = res.data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    getAcadamicYearsList: async function () {
      let rows = await http.get(`${CONSTANTS.API_URL}/api/franchiseeAcademicYears`)
      this.acadamicYearData = rows.data.rows
      // console.log('___Acad Years__', this.acadamicYearData)
    }
  }
}
</script>

<style scoped>
.header-title {
  font-size: 16px;
  color: dimgray;
}
.hr-divider {
  border: solid white;
  border-bottom: solid 3px rgba(0, 0, 0, 0.42);
}
.overall-score {
  position: absolute;
  right: 165px;
  top: 45px;
  z-index: 1;
}
.percentage {
  color: #fff;
  font-size: 9px;
}
.desc {
  font-size: 18px;
}
.theme--light.v-sheet--outlined {
  border: none !important;
}

@media screen and (max-width: 510px) {
  .overall-score {
    visibility: hidden;
  }
}
</style>
